<template>
  <div class="box">
  	<HeaderBar></HeaderBar>
  	<div>
  		<div class="banner" >
        <swiper class="mySwiper" :options="swiperOptions">
          <swiper-slide>
            <img  @click="toRescue" class="item" src="../assets/swiper-item1.jpg" />
          </swiper-slide>
          <swiper-slide>
            <img @click="tocqsj" class="item" src="../assets/swiper-item2.jpg" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="lingqufuli">
        <div class="lingqufuliBtn" @click="toRescue"></div>
      </div>
  		<ul class="list">
          <li @click="toWelfare">
            <span></span>
            <h6>会员福利</h6>
          </li>
          <li @click="toH5" class="list2-zd">
            <span></span>
            <h6>微信服务</h6>
          </li>
  		    <router-link :to="{path: '/selfCheck'}" tag="li" @click.native="countNumber(1,2)">
            <span></span>
            <h6>自助查询</h6>
          </router-link>
         <router-link :to="{path: '/commonSec'}" tag="li" @click.native="countNumber(1,1)">
    				<span></span>
    				<h6>常用服务</h6>
          </router-link>
            <router-link :to="{path: '/selfPush'}" tag="li" @click.native="countNumber(1,3)">
            <span></span>
            <h6>自助递交</h6>
          </router-link>
            <router-link :to="{path: '/service'}" tag="li" @click.native="countNumber(1,4)">
            <span></span>
            <h6>人工服务</h6>
          </router-link>
  			
  		</ul>
  	</div>
  </div>
</template>
<script>
import HeaderBar from './base/header'
import Footer from './base/footer'
import countNumber from '../js/count.js'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    HeaderBar,
    Footer,
    Swiper,
    SwiperSlide
  },
  name: 'index',
  data () {
    return {
      lingqu: 'https://iq.sdo.com/2PX',
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },
        speed:1500,
        loop:true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
      }
    }
  },
  methods:{
   toRescue() {
     window.location.href = this.lingqu;
   },
   toH5() {
     window.location.href = 'https://iq.sdo.com/2PX';
   },
   toWelfare() {
     window.location.href = 'https://iq.sdo.com/2PX';
   },
   tocqsj() {
     window.location.href = 'https://woool.web.sdo.com/';
   }

   //https://woool.sdo.com
  },
  mounted () {
    this.countNumber(1,0)
  }

}
</script>


<style scoped>

.box,body{background: #e6e6e6;height: 100% ; width: 100vw; overflow: hidden;}
.list2-zd{
}
.mySwiper{width:100vw; height: 81.46vw; overflow: hidden;}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  width: 100vw !important;
}
.swiper-container{
  --swiper-theme-color: #f8a34d;
  --swiper-pagination-color: #f8a34d;/* 两种都可以 */
}
.banner .item {
  width: 100vw;
}
.lingqufuli{
  position: relative;
  margin-top: 2vw;
  width: 100%;
  height: 30vw;
  background: url(../assets/lingqufuli.png) no-repeat;
  background-size: cover;
}
.lingqufuliBtn {
  position: absolute;
  width: 34.26vw;
  height: 9.7vw;
  right: 2.53vw;
  bottom: 3vw;
}
.list{overflow:hidden;padding-top: 0.16rem}
.list li{width:3.5rem;height: 2.68rem;font-size: 26px;font-weight: normal;text-align: center;float: left;background: #fff;margin-left: 0.16rem;margin-bottom: 0.16rem}
.list li h6{margin-top: 3vw}
.list li:nth-of-type(1) span{width: 13.8vw;height: 13.4vw; background: url(../assets/fuli-active.png) no-repeat; background-size: cover;margin-top: 0.45rem;display: inline-block;}
.list li:nth-of-type(2) span{width: 15vw;height: 13.4vw; background: url(../assets/weixin.png) no-repeat; background-size: cover;margin-top: 0.45rem;display: inline-block;}
.list li:nth-of-type(4) span{width: 15.2vw;height: 13.4vw;background: url(../assets/changyong.png) no-repeat; background-size: cover;margin-top: 0.45rem;display: inline-block;}
.list li:nth-of-type(3) span{width: 0.9rem;height: 0.92rem;background: url(../assets/zizhu.png) no-repeat; background-size: cover;margin-top: 0.5rem;display: inline-block;}
.list li:nth-of-type(5) span{width: 0.87rem;height: 0.95rem;background: url(../assets/dijiao.png) no-repeat; background-size: cover;margin-top: 0.44rem;display: inline-block;}
.list li:nth-of-type(6) span{width: 0.99rem;height: 0.95rem;background: url(../assets/rengong.png) no-repeat; background-size: cover;margin-top: 0.47rem;display: inline-block;}
.list .active{color:#f8a34d }



</style>



// WEBPACK FOOTER //
// src/components/index.vue